import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

const FirmwareUpdateRebootingDialog = ({ onClose }) => (
  <>
    <DialogTitle variant="h3" sx={{ textAlign: 'center' }}>
      <Trans i18nkey="error.firmware_rebooting.title">Robot is Rebooting</Trans>
    </DialogTitle>
    <DialogContent>
      <Trans i18nKey="firmware.rebooting.message">Once your robot stops pulsing orange, you can scan and reconnect.</Trans>
    </DialogContent>
    <DialogActions>
      <Stack direction="column" width="100%">
        <Button variant="contained" onClick={onClose}>
          <Trans i18nKey="button.close" />
        </Button>
      </Stack>
    </DialogActions>
  </>
);

FirmwareUpdateRebootingDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default FirmwareUpdateRebootingDialog;
